import { HpApiWebApiError } from '@zg-rentals/ts-hotpads-api-client';

// Retires the current code server-side: further digits cannot succeed against it, so stop
// accepting verify attempts until a new code replaces it.
export const CODE_SPENT_REASONS = new Set<HpApiWebApiError>([HpApiWebApiError.CODE_ATTEMPTS_EXCEEDED]);

// Exhausts the address's send budget for the window, so no amount of waiting out the
// cooldown will help. A code already in the inbox stays redeemable, so these block sends
// without locking verification.
export const SEND_BLOCKED_REASONS = new Set<HpApiWebApiError>([
  HpApiWebApiError.SEND_LIMIT_EXCEEDED,
  HpApiWebApiError.TOO_MANY_REQUESTS,
]);
